import { combineReducers } from '@reduxjs/toolkit'
import { type StateType } from 'typesafe-actions'
import agentSmithApi from './agent-smith/agent-smith.slice'
import backendApi from './backend/backend.slice'
import billingApi from './billing/billing.slice'
import bookingApi from './booking/booking.slice'
import entities from './entities'
import global from './global/global.reducer'
import inboxApi from './inbox/inbox.slice'
import integrationsApi from './integrations/integrations.slice'
import loyaltyApi from './loyalty/loyalty.slice'
import morpheusApi from './morpheus/morpheus.slice'
import neoApi from './neo/neo.api'
import tankApi from './tank/tank.slice'
import reportsApi from './reports/reports.slice'
import serviceApi from './service/service.slice'
import wifiApi from './wifi/wifi.slice'
import zionApi from './zion/zion.slice'
import sitesApi from './sites/sites.slice'
import cypherApi from './cypher/cypher.slice'
import { notificationsApi } from './notifications/notifications.slice'
import vpnApi from './vpn/vpn.api'
import trunkApi from './trunk/trunk.slice'
import netxlApi from './netxl/netxl.api'
import eveApi from './eve/eve.slice'
import operatorApi from './operator/operator.slice'
import mouseApi from './mouse/mouse.slice'
import action from './action.reducer'
// -----------------------------------------------------------------------------
// REDUCER

const reducers = {
  entities,
  global,
  action,
  [backendApi.reducerPath]: backendApi.reducer,
  [serviceApi.reducerPath]: serviceApi.reducer,
  [bookingApi.reducerPath]: bookingApi.reducer,
  [morpheusApi.reducerPath]: morpheusApi.reducer,
  [neoApi.reducerPath]: neoApi.reducer,
  [tankApi.reducerPath]: tankApi.reducer,
  [zionApi.reducerPath]: zionApi.reducer,
  [wifiApi.reducerPath]: wifiApi.reducer,
  [integrationsApi.reducerPath]: integrationsApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [inboxApi.reducerPath]: inboxApi.reducer,
  [billingApi.reducerPath]: billingApi.reducer,
  [loyaltyApi.reducerPath]: loyaltyApi.reducer,
  [agentSmithApi.reducerPath]: agentSmithApi.reducer,
  [sitesApi.reducerPath]: sitesApi.reducer,
  [cypherApi.reducerPath]: cypherApi.reducer,
  [notificationsApi.reducerPath]: notificationsApi.reducer,
  [vpnApi.reducerPath]: vpnApi.reducer,
  [trunkApi.reducerPath]: trunkApi.reducer,
  [netxlApi.reducerPath]: netxlApi.reducer,
  [eveApi.reducerPath]: eveApi.reducer,
  [operatorApi.reducerPath]: operatorApi.reducer,
  [mouseApi.reducerPath]: mouseApi.reducer,
}
export type RootState = StateType<typeof reducers>

const rootReducer = combineReducers(reducers)

export { rootReducer }
